<template>
  <div :class="[{ 'rounded-sm border': hasBorder }, { expanded: isOpen }]">
    <div
      class="toggle-section__header flex cursor-pointer items-center px-4 pt-5"
      :class="{ 'border-b': isOpen && $slots.content && hasHeaderBottomBorder }"
      @click.stop="toggleOpen"
    >
      <span v-if="chevronPosition === 'left'" class="chevron pb-5">
        <icon-button>
          <dropdown-chevron
            :is-open="isOpen"
            :is-default-position="false"
            class="icon-base absolute inset-1/2 -translate-x-1/2 -translate-y-1/2 transform text-grey-icon"
          />
        </icon-button>
      </span>
      <div
        class="toggle-section__title flex w-full justify-between pb-5"
        :class="headerClass"
      >
        <slot name="titleSection" />
        <slot name="advanced" />
        <span v-if="chevronPosition === 'right'" class="chevron mb-0 h-10">
          <icon-button>
            <dropdown-chevron
              :is-open="isOpen"
              :is-default-position="false"
              class="icon-base absolute inset-1/2 -translate-x-1/2 -translate-y-1/2 transform text-grey-icon"
            />
          </icon-button>
        </span>
      </div>
    </div>
    <div
      v-if="isOpen && $slots.content"
      :class="{ 'p-5': hasPadding, 'bg-ghost-white': contentGray }"
    >
      <slot name="content" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { type PropType } from "vue";

import IconButton from "@/components/ui/buttons/IconButton.vue";

const props = defineProps({
  isOpen: {
    type: Boolean,
    default: false,
  },
  section: {
    type: String,
    required: true,
  },
  hasPadding: {
    type: Boolean,
    default: true,
  },
  hasBorder: {
    type: Boolean,
    default: true,
  },
  chevronPosition: {
    type: String as PropType<"left" | "right" | "">,
    default: "left",
  },
  hasHeaderBottomBorder: {
    type: Boolean,
    default: true,
  },
  contentGray: {
    type: Boolean,
    default: false,
  },
  headerClass: {
    type: String,
    default: "items-center",
  },
});
const emit = defineEmits<{
  (eventName: "toggle", key: string): void;
}>();
const toggleOpen = () => {
  emit("toggle", props.section);
};
</script>
